import React, { useMemo, useState } from 'react'
import LabelWithInput from './LabelWithInput'
import TmoButton from '../tmoButtons/TmoButton'
import classNames from 'classnames'
import TmoSvg from '../tmoUiHelpers/TmoSvg'

import stringUtils from '../tmoUtilities/string'

import style from './TmoForm.module.css'

function TmoForm({
  className,
  formLabel,
  fieldSpecs = [],
  onSubmit,
  submitText,
  onCancel,
  modalType = '',
  testId
}) {
  const [fieldValues, setFieldValues] = useState(
    fieldSpecs
      .filter((f) => f.defaultValue)
      .reduce(
        (acc, cur) => ({
          ...acc,
          [cur.fieldName]: cur.defaultValue
        }),
        {}
      )
  )

  const keys = useMemo(
    () => fieldSpecs.map((f) => stringUtils.getRandomString()),
    [fieldSpecs]
  )

  const handleChange = ({ fieldName, newValue }) => {
    setFieldValues({
      ...fieldValues,
      [fieldName]: newValue
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit(fieldValues)
  }

  return (
    <form
      className={classNames(className, style[modalType])}
      onSubmit={handleSubmit}
      role='form'
      aria-label={formLabel || 'form'}
      data-testid={testId}
    >
      <div
        className={style.scrollable_content}
        data-testid='scrollableContentTestID'
      >
        {fieldSpecs.map(({ fieldName, defaultValue, ...rest }, index) => (
          <LabelWithInput
            {...rest}
            key={rest.key || keys[index]}
            value={fieldValues[fieldName]}
            onChange={(newValue) => handleChange({ fieldName, newValue })}
          />
        ))}
      </div>
      {modalType && modalType === 'slide' ? (
        <div className={style.footer_wrapper} data-testid='modalFooterTestID'>
          <TmoButton
            onClick={onCancel}
            icon={
              <TmoSvg className={style.button_icon} svgId='icon-close-modal' />
            }
            aria-label={'Cancel'}
            type='magenta_secondary'
            position='top'
          >
            Cancel
          </TmoButton>
          <TmoButton
            buttonType='submit'
            icon={
              <TmoSvg className={style.button_icon} svgId='icon-check-modal' />
            }
            type='magenta_primary'
            position='top'
            aria-label={submitText || 'Submit'}
          >
            {submitText || 'Submit'}
          </TmoButton>
        </div>
      ) : (
        <div className={style.submit}>
          <TmoButton aria-label={submitText || 'Submit'} buttonType='submit'>
            {submitText || 'Submit'}
          </TmoButton>
        </div>
      )}
    </form>
  )
}

export default TmoForm
